/**
 * Lời gọi API cho MH-17/MH-18 lịch phát, đúng hình dạng của
 * `apps/api/src/lich-phat/lich-phat.controller.ts` và `dto.ts`.
 */
import { chuoiTruyVan, goi } from './goi-chung';
import type { TrangDuLieu } from './thiet-bi-api';

export interface ThoiDiemPhatDV {
  ThoiGianBatDau: number;
  ThoiGianKetThuc: number;
}
export interface NgayPhatDV {
  NgayPhat: number;
  ThoiDiemPhat: ThoiDiemPhatDV[];
}
export interface DiaBanNhanDV {
  DichID: string;
  TenDich?: string;
  CumLoaID?: string[];
}
export interface KhungGioTrongNgayVao {
  thoiGianBatDau: number;
  thoiGianKetThuc: number;
}
export type MucDoUuTien = '1' | '2' | '3';
export type LoaiLich = 'theo_ngay' | 'hang_ngay';

export interface LichPhatNoiBoVao {
  tenLichPhat: string;
  banTinIds: string[];
  phamVi: DiaBanNhanDV[];
  loaiLich?: LoaiLich;
  mucDoUuTien?: MucDoUuTien;
  danhSachNgayPhat?: NgayPhatDV[];
  ngayBatDauPhat?: number;
  ngayKetThucPhat?: number;
  thuTrongTuan?: number[];
  khungGioTrongNgay?: KhungGioTrongNgayVao[];
}

export interface LichPhatNoiBoRa {
  id: string;
  lichPhatId: string;
  tenLichPhat: string;
  banTinIds: string[];
  phamVi: DiaBanNhanDV[];
  loaiLich: LoaiLich;
  mucDoUuTien: MucDoUuTien;
  thuTrongTuan: number[];
  danhSachNgayPhat: NgayPhatDV[];
  ngayBatDauPhat: number | null;
  ngayKetThucPhat: number | null;
  trangThai: 'hieu_luc' | 'da_huy';
  createdAt: string;
  /* Trường bổ sung cho trang danh sách lịch (hợp đồng A0). Khai báo tuỳ chọn để
     vẫn chạy được với bản máy chủ cũ chưa trả các trường này. */
  updatedAt?: string;
  hieuLuc?: HieuLucLich;
  tenDiaBan?: string;
  /** 0 = phát tới tất cả thiết bị trong địa bàn. */
  soThietBi?: number;
  soNgayPhat?: number;
  tenNguoiTao?: string | null;
}

/** Hiệu lực của lịch do máy chủ tính: còn hiệu lực, hết hiệu lực, đã hủy. */
export type HieuLucLich = 'con_hieu_luc' | 'het_hieu_luc' | 'da_huy';

export interface BoLocLichPhat {
  page?: number;
  pageSize?: number;
  /** Mã định danh địa bàn. */
  nguonId?: string;
  /** Tìm theo tên lịch. */
  keyword?: string;
  /** Bỏ trống = tất cả. */
  trangThai?: HieuLucLich;
  /** Epoch giây (00:00 giờ Việt Nam ngày bắt đầu); nhận cả chuỗi để tương thích nơi gọi cũ. */
  tuThoiDiem?: number | string;
  /** Epoch giây (24:00 giờ Việt Nam ngày kết thúc). */
  denThoiDiem?: number | string;
}

export const lichPhatApi = {
  danhSach: (tham: BoLocLichPhat, signal?: AbortSignal): Promise<TrangDuLieu<LichPhatNoiBoRa>> =>
    goi(`/api/v1/schedules${chuoiTruyVan(tham as Record<string, string | number | undefined>)}`, { signal }),

  layMot: (id: string, signal?: AbortSignal): Promise<LichPhatNoiBoRa> =>
    goi(`/api/v1/schedules/${id}`, { signal }),

  tao: (than: LichPhatNoiBoVao): Promise<{ id: string; lichPhatId: string; canhBaoTrung: unknown }> =>
    goi('/api/v1/schedules', { phuongThuc: 'POST', than }),

  sua: (id: string, than: LichPhatNoiBoVao): Promise<{ id: string; canhBaoTrung: unknown }> =>
    goi(`/api/v1/schedules/${id}`, { phuongThuc: 'PUT', than }),

  /** Gửi lại gói lịch DV002 xuống bộ tương thích (nút "Phát lịch", bổ sung ngoài OpenAPI). */
  guiLai: (
    id: string,
  ): Promise<{ id: string; daGui: boolean; soNhaCungCap: number; soLoi: number; loi: string[] }> =>
    goi(`/api/v1/schedules/${encodeURIComponent(id)}/resend`, { phuongThuc: 'POST' }),
  huy: (id: string): Promise<{ id: string; trangThai: string }> =>
    goi(`/api/v1/schedules/${id}`, { phuongThuc: 'DELETE' }),
};
